var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 180,
    viewBox: "0 0 181 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.333 164.999C131.754 164.999 165.333 131.42 165.333 89.999C165.333 48.5777 131.754 14.999 90.333 14.999C48.9117 14.999 15.333 48.5777 15.333 89.999C15.333 131.42 48.9117 164.999 90.333 164.999Z",
    fill: "#F0F2FF",
    stroke: "#0020F5",
    strokeWidth: 8.18182
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5833 127.501C74.071 109.184 106.407 108.322 124.083 127.501M109.047 71.251C109.047 81.6062 100.64 90.001 90.2695 90.001C79.9 90.001 71.493 81.6062 71.493 71.251C71.493 60.8957 79.9 52.501 90.2695 52.501C100.64 52.501 109.047 60.8957 109.047 71.251Z",
    stroke: "#0020F5",
    strokeWidth: 8.18182,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.468bdecc494bd2ffc0377900fb95f2e9.svg";
export { ForwardRef as ReactComponent };